import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { staggerContainer } from '@redpandev/ui';

/**
 * Grille responsive des jeux du hub (spec 05 §4.1 & §7) :
 * 1 colonne (mobile) → 2 (`md`) → 3 (`lg+`), entrée des cartes en cascade
 * (les `GameCard` enfants portent le variant `popIn`).
 */
export type HubGridProps = {
  /** Nom accessible de la section (défaut : « Jeux disponibles »). */
  label?: string;
  className?: string;
  children: ReactNode;
};

export function HubGrid({ label = 'Jeux disponibles', className, children }: HubGridProps) {
  return (
    <motion.section
      aria-label={label}
      variants={staggerContainer(0.08, 0.1)}
      initial="hidden"
      animate="visible"
      className={
        'grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3' +
        (className ? ` ${className}` : '')
      }
    >
      {children}
    </motion.section>
  );
}
